import UserSetting from './UserSetting'

export default UserSetting
